var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "top" },
        [
          _vm._v("\n    商家:\n    "),
          _c("supply-select", {
            on: {
              change: function(e) {
                _vm.supply_id = e
              }
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.showDialog } },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "inline", "margin-left": "20px" } },
            [
              _c(
                "el-upload",
                {
                  ref: "supplyfile",
                  staticStyle: { display: "inline" },
                  attrs: {
                    name: "import_file",
                    action: _vm.action,
                    data: { ptype: _vm.is_early_plan ? 11 : 2 },
                    "auto-upload": true,
                    limit: 1,
                    "show-file-list": false,
                    "on-success": _vm.uploadedSuccess,
                    "with-credentials": ""
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "trigger", type: "warning" },
                      slot: "trigger"
                    },
                    [_vm._v("导入商品数据")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.is_early_plan
                ? _c(
                    "div",
                    {
                      staticStyle: { display: "inline", "margin-left": "10px" }
                    },
                    [
                      _vm._v(
                        "\n        导入格式: A列=商家ID, B列=SKU编号, C列=计划数量,\n        D列=入仓标签(赠品、特价、常规、商家自荐)\n      "
                      )
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticStyle: { display: "inline", "margin-left": "10px" }
                    },
                    [
                      _vm._v(
                        "\n        导入格式: A列=商家ID, B列=SKU编号, C列=计划数量,\n        D列=入仓标签(备货、赠品、特价、常规、买手小店)\n      "
                      )
                    ]
                  )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("plan-goods-select", {
        ref: "planGoodsSelect",
        attrs: { goods_label: _vm.options.goods_label },
        on: { submit: _vm.goodsSelected }
      }),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: {
            data: _vm.goods,
            border: "",
            "max-height": "700px",
            size: "small"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", type: "index", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "goods_name", label: "商品名称", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "goods_label", label: "入仓标签", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: scope.row.goods_label,
                          callback: function($$v) {
                            _vm.$set(scope.row, "goods_label", $$v)
                          },
                          expression: "scope.row.goods_label"
                        }
                      },
                      _vm._l(_vm.options.goods_label, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { value: item.value, label: item.label }
                        })
                      }),
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "brand_name", label: "品牌", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "goods_no", label: "商品货号", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "goods_img", label: "图片", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [{ name: "viewer", rawName: "v-viewer" }],
                        staticStyle: {
                          width: "40px",
                          height: "40px",
                          overflow: "hidden",
                          cursor: "pointer",
                          display: "inline-block"
                        }
                      },
                      _vm._l(scope.row.middle_img, function(item, key) {
                        return _c("img", {
                          key: key,
                          staticStyle: {
                            "max-width": "100%",
                            "max-height": "100%"
                          },
                          attrs: { src: item }
                        })
                      }),
                      0
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "co_val", label: "商品颜色", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "si_val", label: "商品尺码", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "picker_group",
              label: "商品数量",
              align: "center",
              width: "180px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { min: 1, size: "small" },
                      model: {
                        value: scope.row.plan_num,
                        callback: function($$v) {
                          _vm.$set(scope.row, "plan_num", $$v)
                        },
                        expression: "scope.row.plan_num"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "pg_name", label: "代采组", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "plan_price", label: "代采价", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "小计", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          ￥" +
                          _vm._s(
                            (
                              scope.row.plan_num * Number(scope.row.plan_price)
                            ).toFixed(2)
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.removeRow(scope.$index)
                          }
                        }
                      },
                      [_vm._v("\n          移除\n        ")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "text-align": "right",
            height: "40px",
            background: "#f3f3f3",
            "line-height": "40px",
            padding: "0 40px",
            "font-size": "14px",
            color: "#ff4040"
          }
        },
        [
          _vm._v(
            "\n    合计数量：" +
              _vm._s(_vm.total.num) +
              "件 合计金额： ¥" +
              _vm._s(_vm.total.price) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "card-title" }, [_vm._v("备注信息")]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { type: "textarea", rows: 3, placeholder: "请输入内容" },
            model: {
              value: _vm.textarea,
              callback: function($$v) {
                _vm.textarea = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "textarea"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.submit }
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.$router.go(-1)
                    }
                  }
                },
                [_vm._v("\n        取消")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cd622e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd622e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wcgplan/EditPlan.vue
// module id = null
// module chunks = 